import styled from 'styled-components';

import {Dialog as MuiDialog} from '@material-ui/core/index';

export const Dialog = styled(MuiDialog).attrs({fullWidth: true, maxWidth: 'md'})`
  margin: 4px 0;
`;
